export const EDITOR_SETTING_NAMES = [
  'is_view',
  'is_view_combo',
  'is_view_msges',
  'is_view_msges_combo',
  'is_view_answers',
  'is_view_answers_combo',
  'is_forbid',
  'is_forbid_combo',
  'is_fold',
  'is_fold_combo',
  'is_freeze',
  'is_freeze_combo',
  'is_hide',
  'is_hide_combo',
  'is_hide_parents',
  'is_one_parent',
  'is_avatar',
  'is_full_tree',
  'is_force_email',
  'is_quote',
  'is_force_pins',
  'is_to_remove',
  'is_left_menu',
  'is_super',
  'is_hidden',
  'is_view_count',
  'is_view_count_0',
  'is_view_count_1',
  'is_view_count_2',
  'is_view_count_3',
  'is_view_count_4',
  'is_view_count_5',
  'is_page_options_color',
  'is_page_options_margin',
  'is_page_options_padding',
  // REGISTERED USERS (docs task §5): positional index 35, additive — the
  // server emits/accepts it only on grant-aware requests.
  'is_reg_users',
] as const

export type EditorSettingName = (typeof EDITOR_SETTING_NAMES)[number]
export type EditorSettingValue = boolean | number | string

export interface EditorFieldModel {
  codeKey?: string
  subject?: string
  nameKey?: string
  smartNameKey?: string
  bodyText?: string
  /** rich (HTML) body mode — mirrors the rough's body_textarea[1].is_html */
  bodyIsHtml?: boolean
  recipientInput?: string
}

export interface EditorPinModel {
  enabled?: boolean
  value?: string
  /** True when parent/forced protection supplies the effective PIN. */
  inherited?: boolean
}

export interface EditorProductCreationModel {
  preview?: string
  poaEnabled?: boolean
}

export interface EditorRulingModel {
  timeStart?: number
  timeStop?: number
  startEnabled?: boolean
  stopEnabled?: boolean
  hideTimeLocked?: boolean
}

export type EditorRulingField = keyof EditorRulingModel
export type EditorSectionName = 'settings' | 'formatting' | 'senderOptions'
export type EditorSettingsTab = 'display' | 'rules' | 'email' | 'counts' | 'timers' | 'protect' | 'avatar' | 'page'

export interface EditorSectionModel {
  open?: boolean
  activeTab?: EditorSettingsTab
}

export interface EditorFormModel {
  nameScope?: string
  nameScopeParent?: string
  mode?: string
  isMsg?: boolean
  isUpdate?: boolean
  draftElId?: number | string | false
  /** Legacy m35 semantics: the Draft button ARMS drafting mode; Save then
   * performs the save as a draft. Projected so the UI can show the armed
   * state (it was invisible — audit 2026-07-19 D3). */
  isDraftingMode?: boolean
  fields: EditorFieldModel
  settings: Partial<Record<EditorSettingName, EditorSettingValue>>
  pins: {
    show: EditorPinModel
    edit: EditorPinModel
  }
  /** Contract-owned pre-create values. They live on the active rough so the
   * Configure modal may close/reopen without losing an unfinished setup. */
  productCreation: EditorProductCreationModel
  ruling: EditorRulingModel
  sections: Partial<Record<EditorSectionName, EditorSectionModel>>
  source: 'legacy-rough' | 'react-facade'
  reason: string
  syncedAt: number
}
